import { IWayPoint } from '../constants/types';

export const waypointStatsAsValue = (waypoint: IWayPoint): number => {
	const parts = waypoint.waypoint_stats.split('/');
	return (Number(parts[0]) / Number(parts[1])) * 100;
};
